<template>
    <modal-base :pacifier="false">
        <template #title>Your Call Was Completed Successfully</template>

        <template #subtitle>We wish you the best of luck with your case!</template>

        <template #extra>
        <hr class="my-8 border-b">

        <div class="flex justify-center">
        <button class="text-center w-full sm:w-auto inline-flex items-center justify-center rounded-full focus:outline-none focus:ring-0 transition py-4 px-6 text-sm sm:text-lg font-medium whitespace-nowrap border bg-brand-teal-light text-white border-transparent hover:bg-brand-teal-light hover:ring-1 hover:ring-offset-1 ring-offset-transparent ring-brand-teal-light"
                @click="scheduleAppointment"
                >
            <span>Schedule another appointment</span>
        </button>
        </div>
        </template>

    </modal-base>
</template>

<script>
    export default {
        mounted() {
            this.$store.commit('card');
        },

        methods: {
            scheduleAppointment() {
                this.$store.commit('modal', 'schedule-appointment');
            }
        }
    }
</script>
